import React from 'react';
import { Checkbox } from '@mui/material';
import { NoItemsYet, SimpleTooltip } from 'components';
import { optionChooseDetailsFromLibraryNotYet } from './constants';
import { renderOptionField } from '../../client/clientSingle/clientClinical/goals/targets/constants';

export const OptionsChooseDetailsFromLibrary = ({ currentFolder, selectedMap, toggleItem }) => {
    return (
        <div className="target-options-wrapper">
            {currentFolder?.options?.length ? (
                <div className="targets-tab-details-block">
                    {currentFolder?.options?.map((option, index) => (
                        <div
                            key={index}
                            className="target-options-row"
                            style={{
                                gap: 10,
                                marginBottom: 0,
                            }}
                        >
                            <SimpleTooltip title={''} placement="top-start">
                                <Checkbox
                                    checked={selectedMap.get(currentFolder.id)?.has(option.id) || false}
                                    onChange={(e) =>
                                        toggleItem({
                                            folderId: currentFolder.id,
                                            optionId: option.id,
                                            checked: e.target.checked,
                                        })
                                    }
                                    name={'checkBox'}
                                    style={{ padding: 0, color: '#0C66E4' }}
                                />
                            </SimpleTooltip>
                            <p className="option-label-box" style={{ width: '100%' }}>
                                {option?.label || '—'}
                            </p>

                            <div className="flex-align-center" style={{ gap: 16 }}>
                                {renderOptionField(currentFolder, option)}
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <NoItemsYet
                    image={optionChooseDetailsFromLibraryNotYet.image}
                    text={optionChooseDetailsFromLibraryNotYet.title}
                    subTitle={optionChooseDetailsFromLibraryNotYet.subTitle}
                    containerStyles={{
                        position: 'static',
                    }}
                    height="fit-content"
                />
            )}
        </div>
    );
};
